export default __webpack_public_path__ + "static/media/mustafa-bashari-ZXQ9m5kgO8Y-unsplash.1196c2d8.jpg";